import { render } from "./PlaceCompetitorModal.vue?vue&type=template&id=194df54c"
import script from "./PlaceCompetitorModal.vue?vue&type=script&lang=ts"
export * from "./PlaceCompetitorModal.vue?vue&type=script&lang=ts"
script.render = render

export default script